<main class="text-start">
  <h2 class="page-title">
    <a [routerLink]="['/products']" class="text-[#8A8AA3] me-0.5 ms-2 hover:text-purple-800">
      <i class="bi" [class.bi-chevron-right]="languageService.isRtl()" [class.bi-chevron-left]="!languageService.isRtl()"></i>
      {{ 'products.back' | translate }}
    </a>
    {{ 'products.details_page_title' | translate }}
  </h2>
    <!-- <h2 class="page-title">
        <i [routerLink]="['/products']" class="bi text-[#8A8AA3] text-sm cursor-pointer"
            [class.bi-chevron-right]="languageService.isRtl()" [class.bi-chevron-left]="!languageService.isRtl()"></i>
        <a [routerLink]="['/products']" class="text-[#8A8AA3] ms-2 me-2">{{ 'products.back' | translate }} </a> {{
        'products.details_page_title' | translate }}
    </h2> -->

    <div *ngIf="!product" class="gray-section animate-pulse">

        <div class="flex justify-end gap-4">
            <div class="bg-gray-200 h-9 xl:w-36 w-32 rounded-md"></div>
            <div class="bg-gray-200 h-9 xl:w-36 w-32 rounded-md"></div>
        </div>

        <div class="flex xl:flex-row-reverse flex-col gap-4 mt-4">

            <div class="white-rounded-container xl:w-3/7 w-full">
                <div class="bg-gray-200 h-5 w-28 rounded mb-4"></div>

                <div class="bg-[#F9FAFB] p-3 rounded-lg border-dashed border-2 border-[#E5E7EB]">
                    <div class="w-full xl:h-96 h-72 bg-gray-200 rounded-lg"></div>
                    <div class="flex flex-wrap gap-3 mt-4">
                        <div *ngFor="let _ of [1,2,3,4,5]" class="w-14 h-14 rounded-md bg-gray-200"></div>
                    </div>
                </div>
            </div>


            <div class="white-rounded-container xl:w-4/7 w-full flex flex-col">

                <div class="flex justify-between">
                    <div class="bg-gray-200 h-6 w-48 rounded"></div>
                    <div class="bg-gray-200 h-7 w-20 rounded"></div>
                </div>

                <div class="flex gap-2 mt-4 self-start">
                    <div *ngFor="let _ of [1,2,3,4,5]" class="w-5 h-5 rounded bg-gray-200">
                    </div>
                </div>

                <div class="bg-gray-200 h-6 w-24 rounded mt-5 self-start"></div>

                <div class="flex gap-2 flex-wrap my-5 self-start">
                    <div *ngFor="let _ of [1,2,3]" class="bg-gray-200 h-10 w-24 rounded-lg"></div>
                </div>

                <div class="space-y-2 mt-6 flex flex-col items-start">
                    <div class="bg-gray-200 h-4 rounded w-full"></div>
                    <div class="bg-gray-200 h-4 rounded w-full"></div>
                    <div class="bg-gray-200 h-4 rounded w-full"></div>
                    <div class="bg-gray-200 h-4 rounded w-[70%]"></div>
                </div>

            </div>
        </div>
    </div>

    <div *ngIf="product" class="gray-section">
        <div class="flex justify-end gap-4">
            <button (click)="deleteProduct()"
                class="xl:text-xs text-[0.7rem] bg-white text-[#F53D6B] border border-gray-300 rounded-md xl:w-36 w-32 py-1.5 cursor-pointer">
                {{ 'products.actions.delete' | translate }} <i class="bi bi-trash ms-2 text-sm"></i>
            </button>
            <button
                class="xl:text-xs text-[0.7rem] bg-[#611F79] text-white rounded-md xl:w-36 w-32 py-1.5 cursor-pointer"
                [routerLink]="['/products', productId, 'edit']">{{ 'products.actions.edit' | translate }}</button>
        </div>
        <div class="flex xl:flex-row-reverse flex-col gap-4 mt-4">
            <div class="white-rounded-container xl:w-3/7 w-full">
                <p class="text-[#4B4B4B] font-medium xl:text-base text-sm">{{ 'products.details.images' | translate }}
                </p>
                <div class="bg-[#F9FAFB] p-3 mt-4 rounded-lg border-dashed border-2 border-[#E5E7EB]">
                    <div class="w-full xl:h-96 flex justify-center items-center">
                        <img class="max-h-full"
                            [src]="selectedImage ? selectedImage.image : 'vendor/products/product-placeholder.png'"
                            alt="">
                    </div>
                    <div class="flex flex-wrap xl:gap-3 gap-2.5 mt-3.5 w-full justify-start">
                        <img *ngFor="let image of selectedVariant?.images" [src]="image.image"
                            (click)="selectImage(image)"
                            class="xl:w-[calc(20%-12px)] w-14 aspect-square object-cover rounded-md cursor-pointer"
                            [ngClass]="image == selectedImage ? 'border-3 border-[#8280FF]' : ''" alt="">
                    </div>
                </div>
            </div>
            <div class="white-rounded-container xl:w-4/7 w-full">
                <div class="flex justify-between">
                    <p class="text-[#4B4B4B] xl:text-base text-sm">{{ languageService.currentLang() === 'ar' ? product.name_ar : (product.name_en || product.name_ar) }}</p>
                    <div [ngClass]="{
                                        'bg-green-100 text-green-800': product.status == 'active',
                                        'bg-yellow-100 text-yellow-800': product.status == 'inactive',
                                        'bg-red-100 text-red-800': product.status == 'deleted',
                                        }" class="py-1 px-2 rounded-md text-[0.7rem]">
                        {{ 'products.status.' + product.status + '_full' | translate }}
                    </div>
                </div>
                <div class="mt-3 xl:text-base text-sm">
                    <span class="me-2 text-sm">&#40;{{ product.reviews_summary != null ?
                        product.reviews_summary.reviews_count : '0' }}&#41;</span>
                    <i class="bi bi-star-fill"
                        [ngClass]="product.reviews_summary != null && product.reviews_summary.avg_rating >= 1 ? 'text-[#FACA15]' : 'text-[#D1D5DB]'"></i>
                    <i class="bi bi-star-fill"
                        [ngClass]="product.reviews_summary != null && product.reviews_summary.avg_rating >= 2 ? 'text-[#FACA15]' : 'text-[#D1D5DB]'"></i>
                    <i class="bi bi-star-fill"
                        [ngClass]="product.reviews_summary != null && product.reviews_summary.avg_rating >= 3 ? 'text-[#FACA15]' : 'text-[#D1D5DB]'"></i>
                    <i class="bi bi-star-fill"
                        [ngClass]="product.reviews_summary != null && product.reviews_summary.avg_rating >= 4 ? 'text-[#FACA15]' : 'text-[#D1D5DB]'"></i>
                    <i class="bi bi-star-fill"
                        [ngClass]="product.reviews_summary != null && product.reviews_summary.avg_rating >= 5 ? 'text-[#FACA15]' : 'text-[#D1D5DB]'"></i>
                </div>
                <p class="mt-2 xl:text-base text-sm">{{ selectedVariant?.price }} {{ 'common.currency' | translate }}
                </p>

                <div class="flex flex-row-reverse justify-end my-3 gap-2.5 flex-wrap">
                    <div *ngFor="let variant of product.variants"
                        class="py-2 px-5 rounded-lg gap-3 border border-[#D1D1DB] text-[#121217] cursor-pointer"
                        [ngClass]="selectedVariant == variant ? 'bg-gray-50': ''" (click)="selectVariant(variant)">
                        <p class="text-xs">
                            <i *ngIf="variant.is_default" class="bi bi-star-fill text-[#FACA15] me-1"></i>
                            {{ languageService.currentLang() === 'ar' ? variant.name_ar : (variant.name_en || variant.name_ar) }}
                        </p>
                    </div>
                </div>


                <p class="text-[#6C6C89] xl:text-sm text-xs mt-5">{{ languageService.currentLang() === 'ar' ? selectedVariant?.description_ar : (selectedVariant?.description || selectedVariant?.description_ar) }}</p>
            </div>
        </div>
        <div class="white-rounded-container mt-3">
            <div class="flex bg-[#F7F7F7] p-3 rounded-lg justify-between">

                <!-- Ratings Breakdown -->



                <div class="ps-2 sm:block hidden">
                    <p class="text-[#8E8E8E] xl:text-sm text-xs">{{ 'products.details.reviews_total' | translate }}</p>
                    <p class="mt-5 xl:text-base text-xs">{{ product.reviews_summary?.reviews_count ?? 0 }} {{
                        'products.details.review_unit' | translate }}</p>
                </div>

                <div class="border-s border-gray-300 ps-5 sm:block hidden">
                    <p class="text-[#8E8E8E] xl:text-sm text-xs">{{ 'products.details.rating_average' | translate }}</p>
                    <p class="mt-5 xl:text-base text-xs">{{ product.reviews_summary?.avg_rating ?? 0}} <i
                            class="bi bi-star-fill text-yellow-400"></i></p>
                </div>

                <div
                    class="xl:space-y-3 space-y-1.5 xl:w-1/3 sm:w-2/4 w-full border-s-0 sm:border-s border-gray-300 ps-2 sm:ps-5 sm:py-0 py-2 sm:pe-0 pe-2">
                    <div *ngFor="let rating of ratings" class="flex flex-row-reverse items-center gap-2">
                        <span class="w-8 text-sm text-gray-600">{{ rating.count }}</span>
                        <div class="flex-1 flex justify-start bg-gray-200 rounded-full h-2">
                            <div class="h-2 rounded-full" [ngClass]="rating.color"
                                [style.width.%]="(rating.count / getRatingsSummary().totalCount) * 100">
                            </div>
                        </div>
                        <span class="flex items-center gap-1 text-sm text-gray-600">
                            <span class="text-yellow-400"><i class="bi bi-star-fill"></i></span>{{ rating.star }}
                        </span>
                    </div>
                </div>


            </div>


            <div *ngIf="reviews && reviews.count">
                <p class="text-[#4B4B4B] font-medium text-sm mt-5">{{ 'products.details.reviews_section_title' |
                    translate }}</p>
                <table class="reviews-table">
                    <tbody>
                        <tr *ngFor="let review of reviews.results">
                            <td class="flex justify-start items-start">
                                <div class="flex justify-start items-center  gap-3">

                                    <img src="dashboard/place-holders/avatar-male.png"
                                        class="xl:w-10 w-8 xl:h-10 h-8  pt-1 rounded-full bg-[#ADE4FF]">
                                    <div class="flex items-center">
                                        <p class="text-[#2F3541] me-2">{{ review.name }}</p>
                                    </div>
                                </div>
                            </td>
                            <td colspan="4">
                                <p class="text-gray-500 text-xs"> {{ getVariantNameById(review.product_variant) }} </p>
                                <div class="xl:text-base text-sm mt-1">
                                    <i class="bi bi-star-fill"
                                        [ngClass]="review.rating >= 1 ? 'text-[#FACA15]' : 'text-[#D1D5DB]'"></i>
                                    <i class="bi bi-star-fill"
                                        [ngClass]="review.rating >= 2 ? 'text-[#FACA15]' : 'text-[#D1D5DB]'"></i>
                                    <i class="bi bi-star-fill"
                                        [ngClass]="review.rating >= 3 ? 'text-[#FACA15]' : 'text-[#D1D5DB]'"></i>
                                    <i class="bi bi-star-fill"
                                        [ngClass]="review.rating >= 4 ? 'text-[#FACA15]' : 'text-[#D1D5DB]'"></i>
                                    <i class="bi bi-star-fill"
                                        [ngClass]="review.rating >= 5 ? 'text-[#FACA15]' : 'text-[#D1D5DB]'"></i>
                                </div>
                                <p> {{ review.comment }} </p>
                            </td>
                            <td [ngClass]="languageService.isRtl() ? 'text-start' : 'text-end'" class="xl:text-base text-sm" dir="ltr"> {{ review.date | date: 'short'}} </td>
                        </tr>
                    </tbody>
                </table>
                <app-table-pagination *ngIf="reviews" [count]="reviews.count" [limit]="pagination.limit"
                    [offset]="pagination.offset" (pageChange)="updatePagination($event)" />
            </div>

        </div>
    </div>
</main>
